export enum TipoPago {
    Indeterminado = 0,
    Contado = 1,
    CuentaCorriente = 2,
    PrevioPago = 3,
    Donacion = 4,
    ConsumoInterno = 5,
    MercadoPago = 6,
    AppYpf = 7,
    Point = 8,
    Anticipada = 9
}